import { TableShipmentInvoice } from './components'
import { ShipmentInvoiceTabProps } from './tab-shipment-invoice.type'

export const TabShipmentInvoice = ({
  isOpenNewShipmentInvoice,
  onHandleOpenNewShipmentInvoice,
}: ShipmentInvoiceTabProps) => {
  return (
    <TableShipmentInvoice
      isOpenNewShipmentInvoice={isOpenNewShipmentInvoice}
      onHandleOpenNewShipmentInvoice={onHandleOpenNewShipmentInvoice}
    />
  )
}
